import React from 'react';
import { Box, Container, Grid, Header } from '@amzn/awsui-components-react';
import { CWBReportSummary } from 'src/models/reports/ReportGenerationSummary';
import ReportSummarySection from './ReportSummarySection';

export default function CWBReportSummarySection({ summary }: { summary?: CWBReportSummary }) {
    if (!summary) {
        return (
            <Grid gridDefinition={[{ colspan: { default: 7, xl: 8 } }, { colspan: { default: 5, xl: 4 } }]}>
                <Container header={<Header variant="h2" description="Calculation Workbook report generation status by workbook">CWB Report Status</Header>}>
                    <Box textAlign="center" padding={{ top: "l", bottom: "l" }} color="inherit"><b>No data available</b><Box variant="p" color="inherit">No CWB report status data available to display</Box></Box>
                </Container>
                <Box textAlign="center" padding={{ top: "xxl", bottom: "l" }} color="inherit">
                    <b>No data available</b><Box variant="p" color="inherit">No CWB chart data available</Box>
                </Box>
            </Grid>
        );
    }
    return (
        <ReportSummarySection
            title="CWB Report Status"
            description="Calculation Workbook report generation status by workbook"
            totalLabel="Total Workbooks"
            totalCount={summary.totalWorkbooks}
            successCount={summary.successCount}
            failureCount={summary.failureCount}
            pendingCount={summary.pendingCount}
            reasonCodeSummary={summary.reasonCodeSummary}
            failedItems={summary.failedWorkbooks.map(w => ({ id: w.workbookId, reasonCode: w.reasonCode }))}
            failedItemIdHeader="Workbook ID"
            failedItemsLabel="Failed Workbooks"
            unitNoun="workbook"
            ariaDescription="Donut chart showing CWB report generation status"
            ariaLabel="CWB report status donut chart"
            emptyDataDescription="No CWB report status data available"
            noMatchDataDescription="No CWB data for the selected filter criteria"
        />
    );
}
